import React from 'react';
import {Row} from 'react-table';
import moment from 'moment';
import {PreleadProject} from 'api';

interface Props {
  row: Row<PreleadProject>;
  value: any;
}

const CustomizeItemDateCell = ({row, value}: Props) => {
  const preleadProject: PreleadProject = row.original;
  const clientPreleadCustomizeItemId = value;

  const customizeItem = React.useMemo(
    () =>
      preleadProject.prelead.customizeItemDates.find(
        (item) =>
          item.clientPreleadCustomizeItemId === clientPreleadCustomizeItemId,
      ),
    [preleadProject, clientPreleadCustomizeItemId],
  );
  return customizeItem?.value
    ? moment(customizeItem?.value).format('YYYY年MM月DD日')
    : null;
};

export default CustomizeItemDateCell;
